function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["href", "disabled", "intent", "mode", "loading", "type", "icon", "iconPosition", "target", "onClick", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import Click from '../click';
import Loading from '../loading';
import Box from '../box';
var getColors = function getColors(_ref, hasIcon) {
  var tokens = _ref.tokens;
  return {
    primary: {
      color: tokens.buttonPrimaryColor,
      foreground: tokens.buttonPrimaryForeground,
      hover: tokens.buttonPrimaryHover
    },
    'primary-alternate': {
      color: tokens.buttonPrimaryAlternateColor,
      foreground: tokens.buttonPrimaryAlternateForeground,
      hover: tokens.buttonPrimaryAlternateHover
    },
    control: {
      color: tokens.buttonControlColor,
      foreground: tokens.buttonControlForeground,
      hover: tokens.buttonControlHover,
      border: tokens.buttonControlBorder
    },
    link: {
      color: tokens.buttonLinkColor,
      foreground: tokens.buttonLinkForeground,
      hover: tokens.buttonLinkHover
    },
    function: {
      foreground: hasIcon ? tokens.buttonFunctionForegroundAlternate : tokens.buttonFunctionForeground,
      hover: hasIcon ? tokens.buttonFunctionHoverAlternate : tokens.buttonFunctionHover,
      hoverForeground: hasIcon ? tokens.buttonFunctionForegroundAlternate : tokens.buttonFunctionHoverForeground
    },
    disclosure: {}
  };
};
var style = function style(_ref2) {
  var disabled = _ref2.disabled,
    intent = _ref2.intent,
    mode = _ref2.mode,
    loading = _ref2.loading,
    hasIcon = _ref2.hasIcon,
    theme = _ref2.theme;
  var _theme$tokens = theme.tokens,
    buttonPaddingHorizontal = _theme$tokens.buttonPaddingHorizontal,
    buttonPaddingVertical = _theme$tokens.buttonPaddingVertical,
    buttonCompactPaddingVertical = _theme$tokens.buttonCompactPaddingVertical,
    buttonCompactPaddingHorizontal = _theme$tokens.buttonCompactPaddingHorizontal;
  var _getColors$intent = getColors(theme, hasIcon)[intent],
    color = _getColors$intent.color,
    foreground = _getColors$intent.foreground,
    hover = _getColors$intent.hover,
    hoverForeground = _getColors$intent.hoverForeground,
    border = _getColors$intent.border;
  return {
    fontSize: 16,
    boxSizing: 'border-box',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    flexShrink: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    appearance: 'none',
    cursor: 'pointer',
    borderRadius: theme.tokens.cornersSmall,
    textAlign: 'center',
    fontFamily: theme.fonts.BODY,
    fontWeight: 500,
    lineHeight: 1,
    transformOrigin: '50% 50%',
    transitionProperty: 'color, background-color, border-color, transform',
    transitionDuration: '120ms, 120ms, 120ms, 50ms',
    transitionTimingFunction: 'ease-in-out',
    ':focus': {
      outline: 0
    },
    extend: [{
      condition: intent === 'primary',
      style: {
        minWidth: 80,
        color: foreground,
        backgroundColor: color,
        paddingHorizontal: mode === 'normal' ? buttonPaddingHorizontal : buttonCompactPaddingHorizontal,
        paddingVertical: mode === 'normal' ? buttonPaddingVertical : buttonCompactPaddingVertical,
        extend: [{
          condition: !disabled && !loading,
          style: {
            ':hover': {
              backgroundColor: hover,
              borderColor: hover
            },
            ':focus': {
              boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.tokens.focusColor,
              ':not(:focus-visible)': {
                boxShadow: 'none'
              }
            },
            ':active': {
              // we need this due to browser overwrites
              color: foreground
            }
          }
        }]
      }
    }, {
      condition: intent === 'primary-alternate',
      style: {
        minWidth: 80,
        color: foreground,
        backgroundColor: color,
        paddingHorizontal: mode === 'normal' ? buttonPaddingHorizontal : buttonCompactPaddingHorizontal,
        paddingVertical: mode === 'normal' ? buttonPaddingVertical : buttonCompactPaddingVertical,
        extend: [{
          condition: !disabled && !loading,
          style: {
            ':hover': {
              backgroundColor: hover,
              borderColor: hover
            },
            ':focus': {
              boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.tokens.focusColor,
              ':not(:focus-visible)': {
                boxShadow: 'none'
              }
            },
            ':active': {
              // we need this due to browser overwrites
              color: foreground
            }
          }
        }]
      }
    }, {
      condition: intent === 'control',
      style: {
        minWidth: 80,
        color: foreground,
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: border,
        paddingHorizontal: mode === 'normal' ? buttonPaddingHorizontal - 1 : buttonCompactPaddingHorizontal - 1,
        paddingVertical: mode === 'normal' ? buttonPaddingVertical - 1 : buttonCompactPaddingVertical - 1,
        extend: [{
          condition: !disabled && !loading,
          style: {
            ':hover': {
              backgroundColor: hover
            },
            ':focus': {
              boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.tokens.focusColor,
              ':not(:focus-visible)': {
                boxShadow: 'none'
              }
            },
            ':active': {
              // we need this due to browser overwrites
              color: foreground
            }
          }
        }]
      }
    }, {
      condition: intent === 'link',
      style: {
        width: 'max-content',
        color: foreground,
        borderBottomColor: color,
        borderBottomWidth: 2,
        borderBottomStyle: 'solid',
        backgroundColor: 'transparent',
        paddingHorizontal: 0,
        paddingVertical: buttonCompactPaddingVertical - 1,
        borderRadius: 0,
        extend: [{
          condition: loading,
          style: {
            borderBottomColor: 'transparent'
          }
        }, {
          condition: !disabled && !loading,
          style: {
            ':hover': {
              borderBottomColor: hover
            },
            ':focus': {
              boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.tokens.focusColor,
              ':not(:focus-visible)': {
                boxShadow: 'none'
              }
            },
            ':active': {
              // we need this due to browser overwrites
              color: foreground
            }
          }
        }]
      }
    }, {
      condition: intent === 'function',
      style: {
        width: 'max-content',
        color: foreground,
        backgroundColor: 'transparent',
        boxSizing: 'content-box',
        marginHorizontal: -buttonCompactPaddingHorizontal,
        paddingHorizontal: buttonCompactPaddingHorizontal,
        paddingVertical: buttonCompactPaddingVertical,
        extend: [{
          condition: !disabled && !loading,
          style: {
            ':hover': {
              backgroundColor: hover,
              color: hoverForeground
            },
            ':focus': {
              boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.tokens.focusColor,
              ':not(:focus-visible)': {
                boxShadow: 'none'
              }
            },
            ':active': {
              // we need this due to browser overwrites
              color: foreground
            }
          }
        }]
      }
    }, {
      condition: !disabled && !loading,
      style: {
        ':active': {
          transform: 'scale(0.98)'
        }
      }
    }, {
      condition: loading,
      style: {
        userSelect: 'none',
        cursor: 'not-allowed',
        color: 'transparent'
      }
    }, {
      condition: disabled,
      style: {
        color: 'foreground.disabled',
        cursor: 'not-allowed',
        textDecorationColor: 'transparent',
        ':active': {
          color: 'foreground.disabled'
        },
        extend: [{
          condition: intent === 'primary',
          style: {
            backgroundColor: 'background.disabled'
          }
        }, {
          condition: intent === 'primary-alternate',
          style: {
            backgroundColor: 'eucalyptus300'
          }
        }, {
          condition: intent === 'control',
          style: {
            borderColor: 'background.disabled'
          }
        }, {
          condition: intent === 'link',
          style: {
            borderBottomColor: 'eucalyptus300'
          }
        }]
      }
    }]
  };
};
var loadingColor = function loadingColor(_ref3) {
  var tokens = _ref3.tokens;
  return {
    primary: tokens.buttonPrimaryLoading,
    'primary-alternate': tokens.buttonPrimaryAlternateLoading,
    control: tokens.buttonControlLoading
  };
};
var ActionButton = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var href = _ref4.href,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    _ref4$intent = _ref4.intent,
    intent = _ref4$intent === void 0 ? 'primary' : _ref4$intent,
    _ref4$mode = _ref4.mode,
    mode = _ref4$mode === void 0 ? 'normal' : _ref4$mode,
    _ref4$loading = _ref4.loading,
    loading = _ref4$loading === void 0 ? false : _ref4$loading,
    type = _ref4.type,
    Icon = _ref4.icon,
    _ref4$iconPosition = _ref4.iconPosition,
    iconPosition = _ref4$iconPosition === void 0 ? 'right' : _ref4$iconPosition,
    target = _ref4.target,
    onClick = _ref4.onClick,
    children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded);
  var _useFela = useFela(),
    theme = _useFela.theme;
  var extend = style({
    intent: intent,
    mode: mode,
    disabled: disabled,
    loading: loading,
    theme: theme,
    hasIcon: Icon
  });
  var buttonProps = _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled,
    extend: extend,
    type: type
  });
  if (loading) {
    return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
      extend: extend,
      ref: ref
    }), /*#__PURE__*/React.createElement(Box, {
      extend: {
        position: 'absolute'
      }
    }, /*#__PURE__*/React.createElement(Loading, {
      size: mode === 'compact' ? 3 : 5,
      thickness: mode === 'compact' ? 2 : 3,
      color: loadingColor(theme)[intent]
    })), children);
  }
  var content = /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    space: 2,
    maxWidth: "100%"
  }, iconPosition === 'left' && Icon && /*#__PURE__*/React.createElement(Icon, null), children, iconPosition === 'right' && Icon && /*#__PURE__*/React.createElement(Icon, null));
  if (href) {
    return /*#__PURE__*/React.createElement(Click, _extends({}, buttonProps, {
      ref: ref,
      href: href,
      target: target
    }), content);
  }
  return /*#__PURE__*/React.createElement(Click, _extends({}, buttonProps, {
    ref: ref,
    onClick: onClick
  }), content);
});
export default ActionButton;
ActionButton.displayName = 'ActionButton';
ActionButton.propTypes = {
  children: PropTypes.node,
  intent: PropTypes.oneOf(['primary', 'primary-alternate', 'control', 'function', 'link']),
  /** Adding href changes the HTML element from `<button>` to `<a>` */
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Allow to open in new window */
  target: PropTypes.oneOf(['_self', '_blank']),
  /** The onClick event handler */
  onClick: PropTypes.func,
  /** Disables the button. The click event handler won't be triggered. */
  disabled: PropTypes.bool,
  /** Enables a loading state. Hover, active and click events aren't triggered anymore. */
  loading: PropTypes.bool,
  /** Renders an input of type="submit" for forms. */
  type: PropTypes.oneOf(['submit', 'reset']),
  /** Padding depending on mode */
  mode: PropTypes.oneOf(['compact', 'normal']),
  /** The icon that should be displayed next to the text. */
  icon: PropTypes.func,
  /** Whether the icon is left or right of the text. */
  iconPosition: PropTypes.oneOf(['left', 'right'])
};